// import { useEffect, useMemo, useState } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { db } from "../../firebase";
// import {
//   doc,
//   getDoc,
//   collection,
//   onSnapshot,
//   query,
//   where,
//   orderBy,
//   addDoc,
//   serverTimestamp,
//   setDoc,
// } from "firebase/firestore";
// import { Clock, CircleDollarSign, MapPin } from "lucide-react";
// import { toast } from "react-hot-toast";
// import { getLockedUserPhone } from "../../utils/phone"; // adjust path

// /* ───────── helpers ───────── */
// const AVATAR_FALLBACK = "/img/user.png";

// function symbolOf(code) {
//   switch (code) {
//     case "USD":
//       return "$";
//     case "EUR":
//       return "€";
//     case "GBP":
//       return "£";
//     case "INR":
//       return "₹";
//     case "LKR":
//       return "Rs";
//     default:
//       return code || "$";
//   }
// }

// // Minimal country list (extend anytime)
// const COUNTRY_OPTIONS = [
//   { code: "LK", name: "Sri Lanka", dial: "+94", min: 9, max: 10 },
//   { code: "IN", name: "India", dial: "+91", min: 10, max: 10 },
//   { code: "US", name: "United States", dial: "+1", min: 10, max: 10 },
//   { code: "GB", name: "United Kingdom", dial: "+44", min: 9, max: 10 },
//   { code: "AE", name: "United Arab Emirates", dial: "+971", min: 8, max: 9 },
//   { code: "SG", name: "Singapore", dial: "+65", min: 8, max: 8 },
//   { code: "AU", name: "Australia", dial: "+61", min: 9, max: 9 },
// ];

// function findCountryByDial(dial) {
//   return COUNTRY_OPTIONS.find((c) => c.dial === dial) || COUNTRY_OPTIONS[0];
// }
// function findCountryByCode(code) {
//   return COUNTRY_OPTIONS.find((c) => c.code === code) || COUNTRY_OPTIONS[0];
// }

// function validateLocalNumber(local, country) {
//   const digits = local.replace(/\D/g, "");
//   return digits.length >= country.min && digits.length <= country.max;
// }

// function NumberCell({ n, filled, locked, selected, onToggle }) {
//   const cls = filled
//     ? "bg-lime-400 text-black font-bold cursor-not-allowed"
//     : locked
//     ? "bg-amber-400 text-black cursor-not-allowed"
//     : selected
//     ? "bg-indigo-400 text-black font-bold"
//     : "bg-slate-700 text-white/90 hover:bg-slate-600 cursor-pointer";
//   return (
//     <div
//       onClick={() => !filled && !locked && onToggle(n)}
//       className={`h-6 rounded text-[11px] leading-6 text-center select-none ${cls}`}
//     >
//       {String(n).padStart(2, "0")}
//     </div>
//   );
// }

// /* ───────── Card Tile (inline buy) ───────── */
// function CardTile({ c, agent, user }) {
//   const nav = useNavigate();
//   const [selected, setSelected] = useState([]);

//   // Phone bits
//   const [storedPhone, setStoredPhone] = useState(""); // already saved E.164
//   const [storedCountry, setStoredCountry] = useState(""); // e.g., "+94"
//   const [country, setCountry] = useState(COUNTRY_OPTIONS[0]);
//   const [localNumber, setLocalNumber] = useState(""); // digits only

//   useEffect(() => {
//     (async () => {
//       if (!user?.uid) return;
//       const { phone, phoneCountry } = await getLockedUserPhone(db, user.uid);
//       if (phone) {
//         setStoredPhone(phone); // keep in state to lock the UI
//         setStoredCountry(phoneCountry || "");
//       }
//     })();
//   }, [user?.uid]);

//   // Preload user's saved phone
//   useEffect(() => {
//     (async () => {
//       if (!user?.uid) return;
//       const u = await getDoc(doc(db, "users", user.uid));
//       if (!u.exists()) return;
//       const data = u.data();
//       const savedPhone = data.phone || data.userMobile || ""; // allow legacy
//       const savedCountry = data.phoneCountry || ""; // like "+94"
//       if (savedPhone) setStoredPhone(savedPhone);
//       if (savedCountry) setStoredCountry(savedCountry);
//       if (savedCountry) setCountry(findCountryByDial(savedCountry));
//     })();
//   }, [user?.uid]);

//   const phoneLocked = !!storedPhone; // if saved, we lock editing here

//   const sold = c.filled?.length || 0;
//   const lockedList = (c.locked || []).filter(
//     (n) => !(c.filled || []).includes(n)
//   );
//   const lockedSet = new Set(lockedList);
//   const filledSet = new Set(c.filled || []);
//   const available =
//     100 - new Set([...(c.filled || []), ...(c.locked || [])]).size;

//   const draw = c.drawAt
//     ? new Date(c.drawAt.toDate?.() || c.drawAt).toLocaleTimeString()
//     : "-";
//   const unitPrice = Number(c.pricePerNumber || 0);
//   const price = `${symbolOf(c.currency)}${unitPrice.toFixed(2)}`;
//   const total = unitPrice * selected.length;

//   const toggle = (n) => {
//     setSelected((prev) =>
//       prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n]
//     );
//   };

//   const computedE164 = useMemo(() => {
//     if (phoneLocked) return storedPhone;
//     const digits = (localNumber || "").replace(/\D/g, "");
//     if (!digits) return "";
//     return `${country.dial}${digits}`;
//   }, [phoneLocked, storedPhone, localNumber, country]);

//   const phoneValid = useMemo(() => {
//     if (phoneLocked) return true;
//     if (!localNumber) return false;
//     return validateLocalNumber(localNumber, country);
//   }, [phoneLocked, localNumber, country]);

//   const submit = async () => {
//     if (!user?.uid) return nav("/login");
//     if (!selected.length) return toast.error("Pick at least one number.");
//     if (!phoneValid || !computedE164)
//       return toast.error("Enter a valid mobile number.");

//     try {
//       // ensure no clashes right before write
//       for (const n of selected) {
//         if (filledSet.has(n) || lockedSet.has(n)) {
//           toast.error(`Number ${n} just got taken. Refresh.`);
//           return;
//         }
//       }

//       // If first-time phone, store it into the user profile and lock for future
//       if (!phoneLocked) {
//         await setDoc(
//           doc(db, "users", user.uid),
//           {
//             phone: computedE164,
//             phoneCountry: country.dial,
//             updatedAt: serverTimestamp(),
//           },
//           { merge: true }
//         );
//         setStoredPhone(computedE164);
//         setStoredCountry(country.dial);
//       }

//       await addDoc(collection(db, "tickets"), {
//         status: "requested",
//         requestedAt: serverTimestamp(),
//         cardId: c.id,
//         agentUid: agent.id,
//         agentName: agent.username || agent.fullName || agent.id?.slice(0, 6),
//         referredByAgent: agent.id,

//         userUid: user.uid,
//         userName: user.displayName || user.email || "Player",
//         userMobileE164: computedE164,
//         userMobile: computedE164,

//         numbers: selected,
//         currency: c.currency || "USD",
//         unitPrice,
//         amount: Number((unitPrice * selected.length).toFixed(2)),
//         referrer: "agent_store",
//       });

//       setSelected([]);
//       toast.success("Request sent! Wait for agent approval.");
//     } catch (e) {
//       console.error(e);
//       toast.error("Could not submit. Try again.");
//     }
//   };

//   return (
//     <div className="rounded-2xl bg-slate-800 p-4 ring-1 ring-slate-700 shadow-lg flex flex-col">
//       <div className="flex items-center justify-between mb-2">
//         <div className="font-semibold truncate">Card #{c.id.slice(0, 8)}…</div>
//         <button
//           onClick={() => {}}
//           className="px-3 py-1 rounded bg-slate-700 text-sm font-semibold"
//           title="You can buy below"
//         >
//           {price}/num
//         </button>
//       </div>

//       <div className="text-xs text-slate-300 flex items-center gap-3 mb-3">
//         <Clock size={14} /> Draw {draw}
//         <span>• Payout {c.payoutPct || 80}%</span>
//         <span className="ml-auto px-2 py-0.5 rounded bg-lime-400 text-black font-bold">
//           {sold}/100
//         </span>
//         <span className="text-slate-300">Avail: {available}</span>
//       </div>

//       <div className="grid grid-cols-10 gap-1">
//         {[...Array(100).keys()].map((n) => (
//           <NumberCell
//             key={n}
//             n={n}
//             filled={filledSet.has(n)}
//             locked={lockedSet.has(n)}
//             selected={selected.includes(n)}
//             onToggle={toggle}
//           />
//         ))}
//       </div>

//       {/* Inline checkout */}
//       <div className="mt-4 p-3 rounded-xl bg-slate-700/60">
//         <div className="text-sm text-slate-200 mb-2">
//           Selected:{" "}
//           {selected.length ? (
//             <span className="font-mono">
//               {selected
//                 .sort((a, b) => a - b)
//                 .map((n) => String(n).padStart(2, "0"))
//                 .join(", ")}
//             </span>
//           ) : (
//             "—"
//           )}
//         </div>

//         {/* Phone capture (lock if saved) */}
//         {user?.uid ? (
//           phoneLocked ? (
//             <div className="mb-2 text-sm text-slate-300">
//               Mobile: <b>{storedPhone}</b>{" "}
//               <span className="text-xs text-slate-400">
//                 (edit in{" "}
//                 <Link className="underline" to="/profile">
//                   Profile
//                 </Link>
//                 )
//               </span>
//             </div>
//           ) : (
//             <div className="grid sm:grid-cols-3 gap-2 mb-2">
//               <select
//                 className="px-3 py-2 rounded bg-slate-800 text-white"
//                 value={country.dial}
//                 onChange={(e) => {
//                   const next = findCountryByDial(e.target.value);
//                   setCountry(next);
//                 }}
//               >
//                 {COUNTRY_OPTIONS.map((c) => (
//                   <option key={c.code} value={c.dial}>
//                     {c.name} ({c.dial})
//                   </option>
//                 ))}
//               </select>
//               <input
//                 className="px-3 py-2 rounded bg-slate-800 text-white sm:col-span-2"
//                 placeholder={`Mobile number (no leading 0), ${country.min}-${country.max} digits`}
//                 value={localNumber}
//                 onChange={(e) =>
//                   setLocalNumber(e.target.value.replace(/\s+/g, ""))
//                 }
//               />
//               {!phoneValid && localNumber && (
//                 <div className="sm:col-span-3 text-xs text-red-300">
//                   Invalid number for {country.name}. Expected {country.min}–
//                   {country.max} digits.
//                 </div>
//               )}
//             </div>
//           )
//         ) : null}

//         <div className="grid sm:grid-cols-3 gap-2">
//           {user?.uid ? (
//             <button
//               onClick={submit}
//               className="px-3 py-2 rounded bg-lime-400 text-black font-semibold disabled:opacity-50"
//               disabled={
//                 !selected.length ||
//                 (!phoneLocked && !phoneValid) ||
//                 (!phoneLocked && !localNumber)
//               }
//             >
//               Buy – {symbolOf(c.currency)}
//               {total.toFixed(2)}
//             </button>
//           ) : (
//             <Link
//               to="/login"
//               className="px-3 py-2 rounded bg-indigo-400 text-black font-semibold text-center"
//             >
//               Login to Buy
//             </Link>
//           )}
//         </div>

//         {!user?.uid && (
//           <div className="text-[11px] text-slate-300 mt-1">
//             You’ll return here after login.
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function MultiCardQuickBuy({ user, agent, cards, refreshKey }) {
//   const [fav, setFav] = useState("");
//   const [count, setCount] = useState(1);
//   const [busy, setBusy] = useState(false);

//   // phone (reuse from profile; simple: require that it already exists)
//   const [userPhone, setUserPhone] = useState("");
//   useEffect(() => {
//     (async () => {
//       if (!user?.uid) return;
//       const s = await getDoc(doc(db, "users", user.uid));
//       if (s.exists()) {
//         const d = s.data();
//         setUserPhone(d.phone || d.userMobile || "");
//       }
//     })();
//   }, [user?.uid, refreshKey]);

//   const doBuy = async () => {
//     if (!user?.uid) return toast.error("Login first.");
//     const n = Number(fav);
//     if (!Number.isInteger(n) || n < 0 || n > 99)
//       return toast.error("Pick a number 00–99.");
//     const k = Math.max(1, Number(count || 1));

//     // Choose up to K cards that have this number free
//     const candidates = [];
//     for (const c of cards) {
//       const filled = new Set(c.filled || []);
//       const locked = new Set(c.locked || []);
//       if (!filled.has(n) && !locked.has(n)) candidates.push(c);
//       if (candidates.length >= k) break;
//     }
//     if (!candidates.length)
//       return toast.error("That number is unavailable on current cards.");

//     setBusy(true);
//     try {
//       for (const c of candidates) {
//         const unitPrice = Number(c.pricePerNumber || 0);
//         await addDoc(collection(db, "tickets"), {
//           status: "requested",
//           requestedAt: serverTimestamp(),
//           cardId: c.id,
//           agentUid: agent.id,
//           agentName: agent.username || agent.fullName || agent.id?.slice(0, 6),
//           referredByAgent: agent.id,

//           userUid: user.uid,
//           userName: user.displayName || user.email || "Player",
//           userMobileE164: userPhone || "",
//           userMobile: userPhone || "",

//           numbers: [n],
//           currency: c.currency || "USD",
//           unitPrice,
//           amount: Number(unitPrice.toFixed(2)),
//           referrer: "agent_store_multicard",
//         });
//       }
//       toast.success(
//         `Requested ${candidates.length} ticket(s) with ${String(n).padStart(
//           2,
//           "0"
//         )}.`
//       );
//     } catch (e) {
//       console.error(e);
//       toast.error("Could not submit. Try again.");
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div className="mb-6 p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700">
//       <div className="font-semibold mb-2">Quick buy across cards</div>
//       <div className="grid sm:grid-cols-5 gap-2">
//         <input
//           className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700 sm:col-span-2"
//           placeholder="Favorite number (00–99)"
//           value={fav}
//           onChange={(e) =>
//             setFav(e.target.value.replace(/\D/g, "").slice(0, 2))
//           }
//         />
//         <input
//           type="number"
//           min={1}
//           className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700"
//           placeholder="# of cards"
//           value={count}
//           onChange={(e) => setCount(Number(e.target.value || 1))}
//         />
//         <button
//           onClick={doBuy}
//           disabled={busy}
//           className="px-3 py-2 rounded bg-lime-400 text-black font-semibold"
//         >
//           {busy ? "Sending…" : "Buy this number"}
//         </button>
//         <div className="text-xs text-slate-400 sm:col-span-5">
//           We’ll request this number on up to {count || 1} of the agent’s active
//           cards where it’s available.
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ───────── Multi-numbers across cards (user requests) ───────── */
// function MultiNumbersAcrossCards({ user, agent, cards, refreshKey }) {
//   const [numsText, setNumsText] = useState(""); // e.g. "21,22,23,24"
//   const [count, setCount] = useState(1); // how many cards to try
//   const [busy, setBusy] = useState(false);

//   // reuse saved phone (same as quick buy)
//   const [userPhone, setUserPhone] = useState("");
//   useEffect(() => {
//     (async () => {
//       if (!user?.uid) return;
//       const s = await getDoc(doc(db, "users", user.uid));
//       if (s.exists()) {
//         const d = s.data();
//         setUserPhone(d.phone || d.userMobile || "");
//       }
//     })();
//   }, [user?.uid, refreshKey]);

//   // helper: parse "24, 36  89" -> [24,36,89]
//   const parseNumbers = (txt = "") => {
//     const set = new Set();
//     for (const raw of String(txt).split(/[^\d]+/g)) {
//       if (!raw) continue;
//       const n = Number(raw);
//       if (Number.isInteger(n) && n >= 0 && n <= 99) set.add(n);
//     }
//     return [...set].sort((a, b) => a - b);
//   };

//   const doRequest = async () => {
//     if (!user?.uid) return toast.error("Login first.");
//     const list = parseNumbers(numsText);
//     if (!list.length) return toast.error("Enter at least one number (00–99).");

//     const k = Math.max(1, Number(count || 1));

//     // choose up to K cards, newest-first, where at least 1 of the numbers is free
//     const candidates = [];
//     for (const c of cards) {
//       const filled = new Set(c.filled || []);
//       const locked = new Set(c.locked || []);
//       const available = list.filter((n) => !filled.has(n) && !locked.has(n));
//       if (available.length) {
//         candidates.push({ card: c, available });
//         if (candidates.length >= k) break;
//       }
//     }
//     if (!candidates.length) {
//       return toast.error("Those numbers are unavailable on current cards.");
//     }

//     setBusy(true);
//     try {
//       for (const { card: c, available } of candidates) {
//         const unitPrice = Number(c.pricePerNumber || 0);
//         const amount = Number((unitPrice * available.length).toFixed(2));
//         await addDoc(collection(db, "tickets"), {
//           status: "requested",
//           requestedAt: serverTimestamp(),
//           cardId: c.id,

//           agentUid: agent.id,
//           agentName: agent.username || agent.fullName || agent.id?.slice(0, 6),
//           referredByAgent: agent.id,

//           userUid: user.uid,
//           userName: user.displayName || user.email || "Player",
//           userMobileE164: userPhone || "",
//           userMobile: userPhone || "",

//           numbers: available, // subset that’s free on this card
//           currency: c.currency || "USD",
//           unitPrice,
//           amount,
//           referrer: "agent_store_multi_numbers",
//         });
//       }
//       toast.success(
//         `Requested on ${candidates.length} card${
//           candidates.length > 1 ? "s" : ""
//         } (numbers: ${list.map((n) => String(n).padStart(2, "0")).join(", ")})`
//       );
//     } catch (e) {
//       console.error(e);
//       toast.error("Could not submit. Try again.");
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div className="mb-6 p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700">
//       <div className="font-semibold mb-2">Buy a list across cards</div>
//       <div className="grid sm:grid-cols-5 gap-2">
//         <input
//           className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700 sm:col-span-3"
//           placeholder="Numbers (comma/space separated, e.g. 21,22,23,24)"
//           value={numsText}
//           onChange={(e) => setNumsText(e.target.value)}
//         />
//         <input
//           type="number"
//           min={1}
//           className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700"
//           placeholder="# of cards"
//           value={count}
//           onChange={(e) => setCount(Number(e.target.value || 1))}
//         />
//         <button
//           onClick={doRequest}
//           disabled={busy || !userPhone}
//           className="px-3 py-2 rounded bg-lime-400 text-black font-semibold disabled:opacity-50"
//           title={!userPhone ? "Add a mobile number in Profile first" : ""}
//         >
//           {busy ? "Sending…" : "Buy these numbers"}
//         </button>
//         <div className="text-xs text-slate-400 sm:col-span-5">
//           We’ll request your list on up to {count || 1} of the agent’s newest
//           active cards where at least one of the numbers is available.
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ───────── Page: Agent Store ───────── */
// export default function AgentStore({ user }) {
//   const { agentId } = useParams();
//   const [agent, setAgent] = useState(null);
//   const [agentProfile, setAgentProfile] = useState(null);
//   const [cards, setCards] = useState([]);

//   // load agent doc
//   useEffect(() => {
//     (async () => {
//       if (!agentId) return;
//       const a = await getDoc(doc(db, "agents", agentId));
//       if (a.exists()) setAgent({ id: a.id, ...a.data() });
//     })();
//   }, [agentId]);

//   // load agent's user profile (for photoURL / avatar / displayName)
//   useEffect(() => {
//     (async () => {
//       if (!agentId) return;
//       const u = await getDoc(doc(db, "users", agentId));
//       if (u.exists()) setAgentProfile({ id: u.id, ...u.data() });
//     })();
//   }, [agentId]);

//   // live cards
//   useEffect(() => {
//     if (!agentId) return;
//     const qy = query(
//       collection(db, "cards"),
//       where("agentUid", "==", agentId),
//       where("status", "==", "active"),
//       orderBy("createdAt", "desc")
//     );
//     const un = onSnapshot(qy, (snap) => {
//       const arr = [];
//       snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
//       setCards(arr);
//     });
//     return () => un();
//   }, [agentId]);

//   // header fields
//   const displayName = useMemo(
//     () =>
//       agent?.username ||
//       agent?.fullName ||
//       agentProfile?.displayName ||
//       agentProfile?.username ||
//       agentProfile?.email ||
//       agent?.id?.slice(0, 6) ||
//       "Agent",
//     [agent, agentProfile]
//   );

//   const avatar =
//     agent?.avatar ||
//     agentProfile?.photoURL ||
//     agentProfile?.avatar ||
//     AVATAR_FALLBACK;

//   const country = agent?.country || "—";
//   const district = agent?.district || "—";
//   const city = agent?.city || "—";
//   const binancePayId = agent?.binancePayId || "";

//   return (
//     <div className="max-w-6xl mx-auto mt-8 md:mt-20">
//       {/* header */}
//       <div className="rounded-2xl bg-slate-800 p-4 ring-1 ring-slate-700 shadow-lg mb-6">
//         <div className="flex items-center gap-4">
//           <img
//             src={avatar}
//             alt={`${displayName} avatar`}
//             onError={(e) => {
//               e.currentTarget.src = AVATAR_FALLBACK;
//             }}
//             className="w-16 h-16 rounded-full object-cover ring-2 ring-slate-600"
//           />
//           <div className="min-w-0">
//             <div className="text-xl font-bold truncate">{displayName}</div>
//             <div className="text-sm text-slate-300 flex items-center gap-2">
//               <MapPin size={14} className="opacity-70" />
//               <span className="truncate">
//                 {city}, {district}, {country}
//               </span>
//             </div>
//             {binancePayId && (
//               <div className="text-xs text-slate-400">
//                 Binance Pay: <span className="font-mono">{binancePayId}</span>
//               </div>
//             )}
//           </div>
//           <div className="ml-auto flex items-center gap-2 text-sm text-slate-300">
//             <CircleDollarSign size={16} className="opacity-70" />
//             <span>Browse & buy from live cards</span>
//           </div>
//         </div>
//       </div>

//       {user && cards.length > 0 && (
//         <>
//           {/* <MultiCardQuickBuy user={user} agent={agent} cards={cards} /> */}
//           <MultiNumbersAcrossCards user={user} agent={agent} cards={cards} />
//         </>
//       )}

//       {/* cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//         {cards.map((c) => (
//           <CardTile key={c.id} c={c} agent={agent} user={user} />
//         ))}
//       </div>

//       {!cards.length && (
//         <div className="mt-6 p-6 rounded-2xl bg-slate-800 text-slate-300">
//           No active cards right now.
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import {
  doc,
  getDoc,
  collection,
  onSnapshot,
  query,
  where,
  orderBy,
  addDoc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { Clock, CircleDollarSign, MapPin } from "lucide-react";
import { toast } from "react-hot-toast";
import { getLockedUserPhone } from "../../utils/phone"; // adjust path

/* ───────── helpers ───────── */
const AVATAR_FALLBACK = "/img/user.png";

function symbolOf(code) {
  switch (code) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "INR":
      return "₹";
    case "LKR":
      return "Rs";
    default:
      return code || "$";
  }
}

// Minimal country list (extend anytime)
const COUNTRY_OPTIONS = [
  { code: "LK", name: "Sri Lanka", dial: "+94", min: 9, max: 10 },
  { code: "IN", name: "India", dial: "+91", min: 10, max: 10 },
  { code: "US", name: "United States", dial: "+1", min: 10, max: 10 },
  { code: "GB", name: "United Kingdom", dial: "+44", min: 9, max: 10 },
  { code: "AE", name: "United Arab Emirates", dial: "+971", min: 8, max: 9 },
  { code: "SG", name: "Singapore", dial: "+65", min: 8, max: 8 },
  { code: "AU", name: "Australia", dial: "+61", min: 9, max: 9 },
];

function findCountryByDial(dial) {
  return COUNTRY_OPTIONS.find((c) => c.dial === dial) || COUNTRY_OPTIONS[0];
}
function validateLocalNumber(local, country) {
  const digits = local.replace(/\D/g, "");
  return digits.length >= country.min && digits.length <= country.max;
}

function NumberCell({ n, filled, locked, selected, onToggle }) {
  const cls = filled
    ? "bg-lime-400 text-black font-bold cursor-not-allowed"
    : locked
    ? "bg-amber-400 text-black cursor-not-allowed"
    : selected
    ? "bg-indigo-400 text-black font-bold"
    : "bg-slate-700 text-white/90 hover:bg-slate-600 cursor-pointer";
  return (
    <div
      onClick={() => !filled && !locked && onToggle(n)}
      className={`h-6 rounded text-[11px] leading-6 text-center select-none ${cls}`}
    >
      {String(n).padStart(2, "0")}
    </div>
  );
}

/* ───────── Card Tile (inline buy) ───────── */
function CardTile({ c, agent, user }) {
  const nav = useNavigate();
  const [selected, setSelected] = useState([]);

  // Phone bits
  const [storedPhone, setStoredPhone] = useState(""); // already saved E.164
  const [storedCountry, setStoredCountry] = useState(""); // e.g., "+94"
  const [country, setCountry] = useState(COUNTRY_OPTIONS[0]);
  const [localNumber, setLocalNumber] = useState(""); // digits only

  useEffect(() => {
    (async () => {
      if (!user?.uid) return;
      const { phone, phoneCountry } = await getLockedUserPhone(db, user.uid);
      if (phone) {
        setStoredPhone(phone); // keep in state to lock the UI
        setStoredCountry(phoneCountry || "");
      }
    })();
  }, [user?.uid]);

  // Preload user's saved phone
  useEffect(() => {
    (async () => {
      if (!user?.uid) return;
      const u = await getDoc(doc(db, "users", user.uid));
      if (!u.exists()) return;
      const data = u.data();
      const savedPhone = data.phone || data.userMobile || ""; // allow legacy
      const savedCountry = data.phoneCountry || ""; // like "+94"
      if (savedPhone) setStoredPhone(savedPhone);
      if (savedCountry) {
        setStoredCountry(savedCountry);
        setCountry(findCountryByDial(savedCountry));
      }
    })();
  }, [user?.uid]);

  const phoneLocked = !!storedPhone; // if saved, we lock editing here

  const sold = c.filled?.length || 0;
  const lockedList = (c.locked || []).filter(
    (n) => !(c.filled || []).includes(n)
  );
  const lockedSet = new Set(lockedList);
  const filledSet = new Set(c.filled || []);
  const available =
    100 - new Set([...(c.filled || []), ...(c.locked || [])]).size;

  const draw = c.drawAt
    ? new Date(c.drawAt.toDate?.() || c.drawAt).toLocaleTimeString()
    : "-";
  const unitPrice = Number(c.pricePerNumber || 0);
  const price = `${symbolOf(c.currency)}${unitPrice.toFixed(2)}`;
  const total = unitPrice * selected.length;

  const toggle = (n) => {
    setSelected((prev) =>
      prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n]
    );
  };

  const computedE164 = useMemo(() => {
    if (phoneLocked) return storedPhone;
    const digits = (localNumber || "").replace(/\D/g, "");
    if (!digits) return "";
    return `${country.dial}${digits}`;
  }, [phoneLocked, storedPhone, localNumber, country]);

  const phoneValid = useMemo(() => {
    if (phoneLocked) return true;
    if (!localNumber) return false;
    return validateLocalNumber(localNumber, country);
  }, [phoneLocked, localNumber, country]);

  const submit = async () => {
    if (!user?.uid) return nav("/login");
    if (!selected.length) return toast.error("Pick at least one number.");
    if (!phoneValid || !computedE164)
      return toast.error("Enter a valid mobile number.");

    try {
      // ensure no clashes right before write
      for (const n of selected) {
        if (filledSet.has(n) || lockedSet.has(n)) {
          toast.error(`Number ${n} just got taken. Refresh.`);
          return;
        }
      }

      // If first-time phone, store it into the user profile and lock for future
      if (!phoneLocked) {
        await setDoc(
          doc(db, "users", user.uid),
          {
            phone: computedE164,
            phoneCountry: country.dial,
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );
        setStoredPhone(computedE164);
        setStoredCountry(country.dial);
      }

      await addDoc(collection(db, "tickets"), {
        status: "requested",
        requestedAt: serverTimestamp(),
        cardId: c.id,
        agentUid: agent.id,
        agentName: agent.username || agent.fullName || agent.id?.slice(0, 6),
        referredByAgent: agent.id,

        userUid: user.uid,
        userName: user.displayName || user.email || "Player",
        userMobileE164: computedE164,
        userMobile: computedE164,

        numbers: selected,
        currency: c.currency || "USD",
        unitPrice,
        amount: Number((unitPrice * selected.length).toFixed(2)),
        referrer: "agent_store",
      });

      // 🎯 success: clear UI
      setSelected([]);
      if (!phoneLocked) setLocalNumber("");
      toast.success("Request sent! Wait for agent approval.");
    } catch (e) {
      console.error(e);
      toast.error("Could not submit. Try again.");
    }
  };

  return (
    <div className="rounded-2xl bg-slate-800 p-4 ring-1 ring-slate-700 shadow-lg flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <div className="font-semibold truncate">Card #{c.id.slice(0, 8)}…</div>
        <button
          onClick={() => {}}
          className="px-3 py-1 rounded bg-slate-700 text-sm font-semibold"
          title="You can buy below"
        >
          {price}/num
        </button>
      </div>

      <div className="text-xs text-slate-300 flex items-center gap-3 mb-3">
        <Clock size={14} /> Draw {draw}
        <span>• Payout {c.payoutPct || 80}%</span>
        <span className="ml-auto px-2 py-0.5 rounded bg-lime-400 text-black font-bold">
          {sold}/100
        </span>
        <span className="text-slate-300">Avail: {available}</span>
      </div>

      <div className="grid grid-cols-10 gap-1">
        {[...Array(100).keys()].map((n) => (
          <NumberCell
            key={n}
            n={n}
            filled={filledSet.has(n)}
            locked={lockedSet.has(n)}
            selected={selected.includes(n)}
            onToggle={toggle}
          />
        ))}
      </div>

      {/* Inline checkout */}
      <div className="mt-4 p-3 rounded-xl bg-slate-700/60">
        <div className="text-sm text-slate-200 mb-2">
          Selected:{" "}
          {selected.length ? (
            <span className="font-mono">
              {selected
                .sort((a, b) => a - b)
                .map((n) => String(n).padStart(2, "0"))
                .join(", ")}
            </span>
          ) : (
            "—"
          )}
        </div>

        {/* Phone capture (lock if saved) */}
        {user?.uid ? (
          phoneLocked ? (
            <div className="mb-2 text-sm text-slate-300">
              Mobile: <b>{storedPhone}</b>{" "}
              <span className="text-xs text-slate-400">
                (edit in{" "}
                <Link className="underline" to="/profile">
                  Profile
                </Link>
                )
              </span>
            </div>
          ) : (
            <div className="grid sm:grid-cols-3 gap-2 mb-2">
              <select
                className="px-3 py-2 rounded bg-slate-800 text-white"
                value={country.dial}
                onChange={(e) => {
                  const next = findCountryByDial(e.target.value);
                  setCountry(next);
                }}
              >
                {COUNTRY_OPTIONS.map((c) => (
                  <option key={c.code} value={c.dial}>
                    {c.name} ({c.dial})
                  </option>
                ))}
              </select>
              <input
                className="px-3 py-2 rounded bg-slate-800 text-white sm:col-span-2"
                placeholder={`Mobile number (no leading 0), ${country.min}-${country.max} digits`}
                value={localNumber}
                onChange={(e) =>
                  setLocalNumber(e.target.value.replace(/\s+/g, ""))
                }
              />
              {!phoneValid && localNumber && (
                <div className="sm:col-span-3 text-xs text-red-300">
                  Invalid number for {country.name}. Expected {country.min}–
                  {country.max} digits.
                </div>
              )}
            </div>
          )
        ) : null}

        <div className="grid sm:grid-cols-3 gap-2">
          {user?.uid ? (
            <button
              onClick={submit}
              className="px-3 py-2 rounded bg-lime-400 text-black font-semibold disabled:opacity-50"
              disabled={
                !selected.length ||
                (!phoneLocked && !phoneValid) ||
                (!phoneLocked && !localNumber)
              }
            >
              Buy – {symbolOf(c.currency)}
              {total.toFixed(2)}
            </button>
          ) : (
            <Link
              to="/login"
              className="px-3 py-2 rounded bg-indigo-400 text-black font-semibold text-center"
            >
              Login to Buy
            </Link>
          )}
        </div>

        {!user?.uid && (
          <div className="text-[11px] text-slate-300 mt-1">
            You’ll return here after login.
          </div>
        )}
      </div>
    </div>
  );
}

function MultiCardQuickBuy({ user, agent, cards, refreshKey }) {
  const [fav, setFav] = useState("");
  const [count, setCount] = useState(1);
  const [busy, setBusy] = useState(false);

  // phone (reuse from profile; simple: require that it already exists)
  const [userPhone, setUserPhone] = useState("");
  useEffect(() => {
    (async () => {
      if (!user?.uid) return;
      const s = await getDoc(doc(db, "users", user.uid));
      if (s.exists()) {
        const d = s.data();
        setUserPhone(d.phone || d.userMobile || "");
      }
    })();
  }, [user?.uid, refreshKey]);

  const doBuy = async () => {
    if (!user?.uid) return toast.error("Login first.");
    const n = Number(fav);
    if (!Number.isInteger(n) || n < 0 || n > 99)
      return toast.error("Pick a number 00–99.");
    const k = Math.max(1, Number(count || 1));

    // Choose up to K cards that have this number free
    const candidates = [];
    for (const c of cards) {
      const filled = new Set(c.filled || []);
      const locked = new Set(c.locked || []);
      if (!filled.has(n) && !locked.has(n)) candidates.push(c);
      if (candidates.length >= k) break;
    }
    if (!candidates.length)
      return toast.error("That number is unavailable on current cards.");

    setBusy(true);
    try {
      for (const c of candidates) {
        const unitPrice = Number(c.pricePerNumber || 0);
        await addDoc(collection(db, "tickets"), {
          status: "requested",
          requestedAt: serverTimestamp(),
          cardId: c.id,
          agentUid: agent.id,
          agentName: agent.username || agent.fullName || agent.id?.slice(0, 6),
          referredByAgent: agent.id,

          userUid: user.uid,
          userName: user.displayName || user.email || "Player",
          userMobileE164: userPhone || "",
          userMobile: userPhone || "",

          numbers: [n],
          currency: c.currency || "USD",
          unitPrice,
          amount: Number(unitPrice.toFixed(2)),
          referrer: "agent_store_multicard",
        });
      }
      toast.success(
        `Requested ${candidates.length} ticket(s) with ${String(n).padStart(
          2,
          "0"
        )}.`
      );
      // 🎯 clear inputs
      setFav("");
      setCount(1);
    } catch (e) {
      console.error(e);
      toast.error("Could not submit. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-6 p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700">
      <div className="font-semibold mb-2">Quick buy across cards</div>
      <div className="grid sm:grid-cols-5 gap-2">
        <input
          className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700 sm:col-span-2"
          placeholder="Favorite number (00–99)"
          value={fav}
          onChange={(e) =>
            setFav(e.target.value.replace(/\D/g, "").slice(0, 2))
          }
        />
        <input
          type="number"
          min={1}
          className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700"
          placeholder="# of cards"
          value={count}
          onChange={(e) => setCount(Number(e.target.value || 1))}
        />
        <button
          onClick={doBuy}
          disabled={busy}
          className="px-3 py-2 rounded bg-lime-400 text-black font-semibold"
        >
          {busy ? "Sending…" : "Buy this number"}
        </button>
        <div className="text-xs text-slate-400 sm:col-span-5">
          We’ll request this number on up to {count || 1} of the agent’s active
          cards where it’s available.
        </div>
      </div>
    </div>
  );
}

/* ───────── Multi-numbers across cards (user requests) ───────── */
function MultiNumbersAcrossCards({ user, agent, cards, refreshKey }) {
  const [numsText, setNumsText] = useState(""); // e.g. "21,22,23,24"
  const [count, setCount] = useState(1); // how many cards to try
  const [busy, setBusy] = useState(false);

  // reuse saved phone (same as quick buy)
  const [userPhone, setUserPhone] = useState("");
  useEffect(() => {
    (async () => {
      if (!user?.uid) return;
      const s = await getDoc(doc(db, "users", user.uid));
      if (s.exists()) {
        const d = s.data();
        setUserPhone(d.phone || d.userMobile || "");
      }
    })();
  }, [user?.uid, refreshKey]);

  // helper: parse "24, 36  89" -> [24,36,89]
  const parseNumbers = (txt = "") => {
    const set = new Set();
    for (const raw of String(txt).split(/[^\d]+/g)) {
      if (!raw) continue;
      const n = Number(raw);
      if (Number.isInteger(n) && n >= 0 && n <= 99) set.add(n);
    }
    return [...set].sort((a, b) => a - b);
  };

  const doRequest = async () => {
    if (!user?.uid) return toast.error("Login first.");
    const list = parseNumbers(numsText);
    if (!list.length) return toast.error("Enter at least one number (00–99).");

    const k = Math.max(1, Number(count || 1));

    // choose up to K cards, newest-first, where at least 1 of the numbers is free
    const candidates = [];
    for (const c of cards) {
      const filled = new Set(c.filled || []);
      const locked = new Set(c.locked || []);
      const available = list.filter((n) => !filled.has(n) && !locked.has(n));
      if (available.length) {
        candidates.push({ card: c, available });
        if (candidates.length >= k) break;
      }
    }
    if (!candidates.length) {
      return toast.error("Those numbers are unavailable on current cards.");
    }

    setBusy(true);
    try {
      for (const { card: c, available } of candidates) {
        const unitPrice = Number(c.pricePerNumber || 0);
        const amount = Number((unitPrice * available.length).toFixed(2));
        await addDoc(collection(db, "tickets"), {
          status: "requested",
          requestedAt: serverTimestamp(),
          cardId: c.id,

          agentUid: agent.id,
          agentName: agent.username || agent.fullName || agent.id?.slice(0, 6),
          referredByAgent: agent.id,

          userUid: user.uid,
          userName: user.displayName || user.email || "Player",
          userMobileE164: userPhone || "",
          userMobile: userPhone || "",

          numbers: available, // subset that’s free on this card
          currency: c.currency || "USD",
          unitPrice,
          amount,
          referrer: "agent_store_multi_numbers",
        });
      }
      toast.success(
        `Requested on ${candidates.length} card${
          candidates.length > 1 ? "s" : ""
        } (numbers: ${list.map((n) => String(n).padStart(2, "0")).join(", ")})`
      );
      // 🎯 clear inputs
      setNumsText("");
      setCount(1);
    } catch (e) {
      console.error(e);
      toast.error("Could not submit. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-6 p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700">
      <div className="font-semibold mb-2">Buy a list across cards</div>
      <div className="grid sm:grid-cols-5 gap-2">
        <input
          className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700 sm:col-span-3"
          placeholder="Numbers (comma/space separated, e.g. 21,22,23,24)"
          value={numsText}
          onChange={(e) => setNumsText(e.target.value)}
        />
        <input
          type="number"
          min={1}
          className="px-3 py-2 rounded bg-slate-900 text-white ring-1 ring-slate-700"
          placeholder="# of cards"
          value={count}
          onChange={(e) => setCount(Number(e.target.value || 1))}
        />
        <button
          onClick={doRequest}
          disabled={busy || !userPhone}
          className="px-3 py-2 rounded bg-lime-400 text-black font-semibold disabled:opacity-50"
          title={!userPhone ? "Add a mobile number in Profile first" : ""}
        >
          {busy ? "Sending…" : "Buy these numbers"}
        </button>
        <div className="text-xs text-slate-400 sm:col-span-5">
          We’ll request your list on up to {count || 1} of the agent’s newest
          active cards where at least one of the numbers is available.
        </div>
      </div>
    </div>
  );
}

/* ───────── Page: Agent Store ───────── */
export default function AgentStore({ user }) {
  const { agentId } = useParams();
  const [agent, setAgent] = useState(null);
  const [agentProfile, setAgentProfile] = useState(null);
  const [cards, setCards] = useState([]);

  // load agent doc
  useEffect(() => {
    (async () => {
      if (!agentId) return;
      const a = await getDoc(doc(db, "agents", agentId));
      if (a.exists()) setAgent({ id: a.id, ...a.data() });
    })();
  }, [agentId]);

  // load agent's user profile (for photoURL / avatar / displayName)
  useEffect(() => {
    (async () => {
      if (!agentId) return;
      const u = await getDoc(doc(db, "users", agentId));
      if (u.exists()) setAgentProfile({ id: u.id, ...u.data() });
    })();
  }, [agentId]);

  // live cards
  useEffect(() => {
    if (!agentId) return;
    const qy = query(
      collection(db, "cards"),
      where("agentUid", "==", agentId),
      where("status", "==", "active"),
      orderBy("createdAt", "desc")
    );
    const un = onSnapshot(qy, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setCards(arr);
    });
    return () => un();
  }, [agentId]);

  // header fields
  const displayName = useMemo(
    () =>
      agent?.username ||
      agent?.fullName ||
      agentProfile?.displayName ||
      agentProfile?.username ||
      agentProfile?.email ||
      agent?.id?.slice(0, 6) ||
      "Agent",
    [agent, agentProfile]
  );

  const avatar =
    agent?.avatar ||
    agentProfile?.photoURL ||
    agentProfile?.avatar ||
    AVATAR_FALLBACK;

  const country = agent?.country || "—";
  const district = agent?.district || "—";
  const city = agent?.city || "—";
  const binancePayId = agent?.binancePayId || "";

  return (
    <div className="max-w-6xl mx-auto mt-8 md:mt-20">
      {/* header */}
      <div className="rounded-2xl bg-slate-800 p-4 ring-1 ring-slate-700 shadow-lg mb-6">
        <div className="flex items-center gap-4">
          <img
            src={avatar}
            alt={`${displayName} avatar`}
            onError={(e) => {
              e.currentTarget.src = AVATAR_FALLBACK;
            }}
            className="w-16 h-16 rounded-full object-cover ring-2 ring-slate-600"
          />
          <div className="min-w-0">
            <div className="text-xl font-bold truncate">{displayName}</div>
            <div className="text-sm text-slate-300 flex items-center gap-2">
              <MapPin size={14} className="opacity-70" />
              <span className="truncate">
                {city}, {district}, {country}
              </span>
            </div>
            {binancePayId && (
              <div className="text-xs text-slate-400">
                Binance Pay: <span className="font-mono">{binancePayId}</span>
              </div>
            )}
          </div>
          <div className="ml-auto flex items-center gap-2 text-sm text-slate-300">
            <CircleDollarSign size={16} className="opacity-70" />
            <span>Browse & buy from live cards</span>
          </div>
        </div>
      </div>

      {user && cards.length > 0 && (
        <>
          {/* <MultiCardQuickBuy user={user} agent={agent} cards={cards} /> */}
          <MultiNumbersAcrossCards user={user} agent={agent} cards={cards} />
        </>
      )}

      {/* cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <CardTile key={c.id} c={c} agent={agent} user={user} />
        ))}
      </div>

      {!cards.length && (
        <div className="mt-6 p-6 rounded-2xl bg-slate-800 text-slate-300">
          No active cards right now.
        </div>
      )}
    </div>
  );
}
